import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    data: {
        tipotalle: undefined,
        response: undefined,
        articuloCompleto: undefined,
        articuloBorrado: undefined,
        articuloImagenes: [],
        articuloImagenesOriginales: [],
        stockImagenes: [],
        contadorImagenesEnviadasAtemporal: 0, 
        listadoArticulo : undefined,
        articuloImagenesListado:[],
        filtrosArticulo: undefined
    }
})

export default function testReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SAGA_INITIAL_STATE){
        return initialState
    }

    if(action.type === ReducerActions.SAGA_GET_LISTADO_ARTICULO){
        return state.setIn(["data", "articuloImagenesListado"], [])
    }

    if(action.type === ReducerActions.SET_TIPOTALLE){
        return state.setIn(["data", "tipotalle"], action.payload)
    }
    
    if(action.type === ReducerActions.SET_FILTERS_BUSQUEDA_ARTICULO){
        return state.setIn(["data", "filtrosArticulo"], action.payload)
    }

    if(action.type === ReducerActions.SET_ARTICULO_BORRADO){
        state.setIn(["data", "articuloBorrado"], action.payload)
    
    let myState = state.toJS();
        let mlistadoArticulo = myState.data.listadoArticulo;
        mlistadoArticulo.listaSuperRubros.forEach(superR => {
            let superRubro = mlistadoArticulo.listaSuperRubros.find(x => x.idSuperRubro === superR.idSuperRubro)
            let indexSuperRubro = mlistadoArticulo.listaSuperRubros.indexOf(superRubro)
            if(superRubro){
                superR.listaRubros.forEach(r => {
                    let rubro = superRubro.listaRubros.find(x => x.idRubro === r.idRubro)
                    let indexRubro = superRubro.listaRubros.indexOf(rubro)
                    if(rubro){
                        r.listaSubRubros.forEach(subR => {
                            let subRubro = rubro.listaSubRubros.find(x => x.idSubrubro === subR.idSubrubro);
                            // let indexSubRubro = rubro.listaSubRubros.indexOf(subRubro);
                            if(subRubro){
                                subR.listaArticulos=subR.listaArticulos.filter(item=>item.idArticulo!==action.payload);
                                
                                //rubro.listaSubRubros[indexSubRubro] = subRubro
                            }
                            else{
                                rubro.listaSubRubros.push(subR)
                            }
                        });
                        superRubro.listaRubros[indexRubro] = rubro
                    }
                    else{
                        superRubro.listaRubros.push(r)
                    }
                })
                mlistadoArticulo.listaSuperRubros[indexSuperRubro] = superRubro
            }
            else{
                mlistadoArticulo.listaSuperRubros.push(superRubro)
            }
        }
        );

        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                listadoArticulo: mlistadoArticulo
            }
        })
    }

    if(action.type === ReducerActions.SET_ARTICULO_COMPLETO){
        return state.setIn(["data", "articuloCompleto"], action.payload)
    }

    if(action.type === ReducerActions.SET_LISTADO_ARTICULO){
        let myState = state.toJS();
        let response = action.payload;
        let mlistadoArticulo = myState.data.listadoArticulo;
        
        if (myState.data.listadoArticulo !== undefined)
        {
            response.listaSuperRubros.forEach(superR => {
                let superRubro = mlistadoArticulo.listaSuperRubros.find(x => x.idSuperRubro === superR.idSuperRubro)
                let indexSuperRubro = mlistadoArticulo.listaSuperRubros.indexOf(superRubro)
                if(superRubro){
                    superR.listaRubros.forEach(r => {
                        let rubro = superRubro.listaRubros.find(x => x.idRubro === r.idRubro)
                        let indexRubro = superRubro.listaRubros.indexOf(rubro)
                        if(rubro){
                            r.listaSubRubros.forEach(subR => {
                                let subRubro = rubro.listaSubRubros.find(x => x.idSubrubro === subR.idSubrubro)
                                let indexSubRubro = rubro.listaSubRubros.indexOf(subRubro)
                                if(subRubro){
                                    subR.listaArticulos.forEach(a => {
                                        let articulo = subRubro.listaArticulos.find(x => x.idArticulo === a.idArticulo)
                                        if(!articulo){
                                            subRubro.listaArticulos.push(a)
                                        }
                                    });
                                    rubro.listaSubRubros[indexSubRubro] = subRubro
                                }
                                else{
                                    rubro.listaSubRubros.push(subR)
                                }
                            });
                            superRubro.listaRubros[indexRubro] = rubro
                        }
                        else{
                            superRubro.listaRubros.push(r)
                        }
                    })
                    mlistadoArticulo.listaSuperRubros[indexSuperRubro] = superRubro
                }
                else{
                    mlistadoArticulo.listaSuperRubros.push(superRubro)
                }
            });
            
            return fromJS({
                ...myState,
                data: {
                    ...myState.data,
                    listadoArticulo: mlistadoArticulo
                }
            })

        }
        else
        {
            return state.setIn(["data", "listadoArticulo"], action.payload);
        }
        
        
    }


    if(action.type === ReducerActions.SET_LISTADO_ENTRADA){
        let myState = state.toJS();
        let response = action.payload;
        let mlistadoArticulo = myState.data.listadoArticulo;
        
        if (myState.data.listadoArticulo !== undefined)
        {
            response.listaSuperRubros.forEach(superR => {
                let superRubro = mlistadoArticulo.listaSuperRubros.find(x => x.idSuperRubro === superR.idSuperRubro)
                let indexSuperRubro = mlistadoArticulo.listaSuperRubros.indexOf(superRubro)
                if(superRubro){
                    superR.listaRubros.forEach(r => {
                        let rubro = superRubro.listaRubros.find(x => x.idRubro === r.idRubro)
                        let indexRubro = superRubro.listaRubros.indexOf(rubro)
                        if(rubro){
                            r.listaSubRubros.forEach(subR => {
                                let subRubro = rubro.listaSubRubros.find(x => x.idSubrubro === subR.idSubrubro)
                                let indexSubRubro = rubro.listaSubRubros.indexOf(subRubro)
                                if(subRubro){
                                    subR.listaArticulos.forEach(a => {
                                        let articulo = subRubro.listaArticulos.find(x => x.idArticulo === a.idArticulo)
                                        if(!articulo){
                                            subRubro.listaArticulos.push(a)
                                        }
                                    });
                                    rubro.listaSubRubros[indexSubRubro] = subRubro
                                }
                                else{
                                    rubro.listaSubRubros.push(subR)
                                }
                            });
                            superRubro.listaRubros[indexRubro] = rubro
                        }
                        else{
                            superRubro.listaRubros.push(r)
                        }
                    })
                    mlistadoArticulo.listaSuperRubros[indexSuperRubro] = superRubro
                }
                else{
                    mlistadoArticulo.listaSuperRubros.push(superRubro)
                }
            });
            
            return fromJS({
                ...myState,
                data: {
                    ...myState.data,
                    listadoArticulo: mlistadoArticulo
                }
            })

        }
        else
        {
            return state.setIn(["data", "listadoArticulo"], action.payload);
        }
        
        
    }

    if (action.type === ReducerActions.SET_IMAGEN_ARTICULO) {
    
        let myState = state.toJS()
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                articuloImagenes: [...myState.data.articuloImagenes, action.payload]
            }
        })
    }

    if(action.type === ReducerActions.SET_IMAGEN_ORIGINAL_ARTICULO){
        let myState = state.toJS()
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                articuloImagenesOriginales: [...myState.data.articuloImagenesOriginales, action.payload]
            }
        })
    }

    if (action.type === ReducerActions.SAGA_SET_IMAGEN_ARTICULO_LISTADO) {
    
        let myState = state.toJS()
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                articuloImagenesListado: [...myState.data.articuloImagenesListado   , action.payload]
            }
        })
    }

    if (action.type === ReducerActions.SET_IMAGEN_STOCK) {
    
        let myState = state.toJS()
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                stockImagenes: [...myState.data.stockImagenes, action.payload]
            }
        })
    }

    if (action.type === ReducerActions.SAGA_ELIMINAR_IMAGEN_TALLECOLOR) {
    
        let myState = state.toJS()
        
        let listaIdTalleColor = action.payload

        let nuevoStock = myState.data.stockImagenes.filter((s) => !listaIdTalleColor.includes(s.idTalleColor))
        
        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                stockImagenes: nuevoStock
            }
        })
    }

    if(action.type === ReducerActions.SAGA_INCREMENTAR_CONTADOR){
        let myState = state.toJS()
        
        let contadorImagenesEnviadasAtemporal = myState.data.contadorImagenesEnviadasAtemporal + 1

        return fromJS({
            ...myState,
            data: {
                ...myState.data,
                contadorImagenesEnviadasAtemporal: contadorImagenesEnviadasAtemporal
            }
        })
    }
   
    return state
}